import classNames from 'classnames';
import { ReactNode, useState } from 'react';
import Typography from '@alltrails/core/components/Typography';
import Chevron from '@alltrails/denali/icons/Chevron';
import styles from './Expandable.module.scss';

type Props = {
  children: ReactNode;
  classes?: string;
  collapsed?: boolean;
  title: ReactNode;
};

const Expandable = ({ title, collapsed = true, classes = '', children }: Props) => {
  const [isCollapsed, toggleIsCollapsed] = useState(collapsed);

  const toggleContent = () => {
    toggleIsCollapsed(prevState => !prevState);
  };

  return (
    <div className={classNames(styles.container, classes)}>
      <button onClick={toggleContent} className={styles.control}>
        <Typography variant="heading300" component="div">
          {title}
        </Typography>
        <div className={styles.toggleButton}>
          <Chevron size="sm" orientation={isCollapsed ? 'down' : 'up'} color="--color-text-secondary" />
        </div>
      </button>
      <div className={isCollapsed ? styles.collapsed : styles.collapsible}>{children}</div>
    </div>
  );
};

export default Expandable;
